import { Navigate, Outlet, useLocation } from 'react-router-dom';

import { useMe } from '../hooks';

export default function ProtectedRoute() {
  const { data: me, isLoading } = useMe();
  const location = useLocation();

  if (isLoading) {
    return (
      <div className="w-full h-screen flex items-center justify-center text-foreground">
        Loading...
      </div>
    );
  }

  if (!me) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  return <Outlet />;
}
